// extracted by mini-css-extract-plugin
export var avatarContainer = "_6q-0";
export var avatarTypingWave = "_6q-i";
export var gray = "_6q-f";
export var green = "_6q-c";
export var icon = "_6q-9";
export var image = "_6q-1";
export var lg = "_6q-6";
export var md = "_6q-5";
export var presenceDot = "_6q-b";
export var red = "_6q-d";
export var sm = "_6q-4";
export var status = "_6q-a";
export var typingDot = "_6q-h";
export var typingPill = "_6q-g";
export var xl = "_6q-7";
export var xs = "_6q-3";
export var xxl = "_6q-8";
export var xxs = "_6q-2";
export var yellow = "_6q-e";